import React from "react";
import PinInput from "react-pin-input";
import { useSelector } from "react-redux";
import useVerifyEmailApi from "../../Global/Api/Settings/verifyEmailApi";
import useTimer from "../../Global/Hooks/timer";
import Popup from "../Popup";

export default function VerifyEmailModal({ setCodeModal }) {
  const { timer, isRunning } = useTimer(60);
  const verifyEmailApi = useVerifyEmailApi();
  const emailVerifyData = useSelector(
    (state) => state.rootReducer.techsbookSlice.changeEmail
  );

  const handleSubmitVerify = (code) => {
    verifyEmailApi.send({
      verify_code: code,
      verify_token: emailVerifyData?.verify_token,
    }, setCodeModal);
  };

  const closeVerify = () => {
    setCodeModal(false);
  };

  return (
    <Popup closePopup={closeVerify} title="Enter verification code">
      <div className="personal__popup">
        <p className="personal__popup-text">
          We’ve sent you verification code, please check your email:{" "}
        </p>
        <p className="personal__popup-email">{emailVerifyData?.email}</p>
        <form onSubmit={handleSubmitVerify} className="personal__form">
          <div className="personal__pin mt20">
            <PinInput
              length={6}
              type="numeric"
              inputMode="number"
              onComplete={(value, index) => {
                handleSubmitVerify(value);
              }}
              autoSelect={true}
              regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
            />
          </div>

          <div className="personal__resend mt24">
            Didn’t receive a code?
            {isRunning ? (
              <div className="personal__link ml4">{timer}</div>
            ) : (
              <div
                // onClick={resendCode}
                className="personal__link ml4"
              >
                Resend code
              </div>
            )}
          </div>
        </form>
      </div>
    </Popup>
  );
}
